export enum FutureOrderConfirmAction {
	CONFIRM = 'confirm',
	CHANGE_DATE = 'change_date',
}
